import React, { useEffect, useCallback, useState, useMemo } from 'react';
import Button from '@material-ui/core/Button';
import { useLocation, history } from 'umi';
import { useDispatch, useSelector } from 'dva';
import qs from 'qs';
import dayjs from 'dayjs';
import SearchCondition from './components/search_condition/index';
import LabelManageResult from './components/label_manage_result/index';
import SearchTree from './components/search_tree/index';
import ModalML from '@/components/ModalML/ModalML';
import LabelModal from './components/label_modal/index';
import LabelManageStyled from './labelManageStyled';
import webStorage from '@/utils/storageManager';

export default () => {
  const MENU_USER_PROFILE_TAG_CREATE = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_USER_PROFILE_TAG_CREATE');
  const dispatch = useDispatch();
  const location = useLocation();
  const [isSearch, setIsSearch] = useState(false);
  const [modification, setModification] = useState({});
  const { query, pathname } = location;
  const [tagId, setTagId] = useState();
  const [tagTreeList, setTagTreeList] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [treeExpanded, setTreeExpanded] = useState([]);
  const [labelOpen, setLabelOpen] = useState(false);
  const [refreshTime, setRefreshTime] = useState(
    dayjs().format('YYYY-MM-DD HH-mm-ss'),
  );
  const id = webStorage.get('DELETE_TAG') ? '' : query?.id;

  // 取type不是7的第一个传入人数
  const tagTree = useSelector((state) => state.labelManage.tagTree);

  useEffect(() => {
    setTagTreeList(tagTree);
  }, [tagTree]);

  // 收藏列表，如果收藏列表为空，则显示第一个标签的收藏状态
  // attrArr 需要提取的公共属性数组(默认是除了childs的全部属性)
  const extractTree = (arrs, childs, attrArr) => {
    // 铺平树
    let attrList = [];
    if (!Array.isArray(arrs) && !arrs.length) {
      return [];
    }
    if (typeof childs !== 'string') {
      return [];
    }
    if (
      !Array.isArray(attrArr) ||
      (Array.isArray(attrArr) && !attrArr.length)
    ) {
      attrList = arrs && Object?.keys(arrs[0]);
      attrList.splice(attrList?.indexOf(childs), 1);
    } else {
      attrList = attrArr;
    }
    let list = [];
    const getObj = (arr) => {
      arr.forEach(function (row) {
        let obj = {};
        attrList.forEach((item) => {
          obj[item] = row[item];
        });
        list.push(obj);
        if (row[childs]) {
          getObj(row[childs]);
        }
      });
      return list;
    };
    return getObj(arrs);
  };

  const tagTreeFlat = useMemo(() => {
    if (tagTree && tagTree?.length > 0) {
      return extractTree(tagTree, 'children');
    }
  }, [tagTree]);

  useEffect(() => {
    // 刚进入页面时发请求
    if (tagTreeFlat && tagTreeFlat?.length > 0) {
      const ids = tagTreeFlat.filter((i) => i.type !== 7);
      const showIds = ids.find((item) => item.status === 1)?.id || ids?.[0]?.id;
      const queryId = id || showIds;
      if (queryId) {
        history.replace(
          `${pathname}?${qs.stringify({
            ...query,
            id: String(queryId),
          })}`,
        );
        setTagId(String(queryId));
      }
    }
  }, [tagTreeFlat, id]);

  // 获取树形数据
  const fetchTagTree = useCallback(() => {
    dispatch({
      type: 'labelManage/getQueryTagTree',
      payload: {
        values: {},
      },
      callback(res) {
        if (res.code === 0) {
          setRefreshTime(dayjs().format('YYYY-MM-DD HH-mm-ss'));
          // label && handleSearch({ label });
        }
      },
    });
  }, [dispatch]);

  useEffect(() => {
    fetchTagTree();
  }, [fetchTagTree]);

  // 获取标签人数
  const fetchTagMember = useCallback(() => {
    dispatch({
      type: 'labelManage/getQueryTagMember',
      payload: {
        values: {
          tagId: tagId,
        },
      },
    });
  }, [dispatch, tagId]);

  useEffect(() => {
    if (tagId) {
      fetchTagMember();
    }
  }, [fetchTagMember, tagId]);

  //查询单个标签基本信息
  const fetchTagInfo = useCallback(() => {
    dispatch({
      type: 'labelManage/getQueryTagInfo',
      payload: {
        values: {
          tagId: tagId,
        },
      },
    });
    setIsSearch(true);
  }, [dispatch, tagId, modification]);

  useEffect(() => {
    if (tagId) {
      fetchTagInfo();
    }
  }, [fetchTagInfo, tagId]);

  //获取收藏列表
  const getQueryFavorite = useCallback(() => {
    dispatch({
      type: 'labelManage/getQueryFavorite',
      payload: {
        values: {},
      },
    });
  }, [dispatch, modification]);

  useEffect(() => {
    getQueryFavorite();
  }, [getQueryFavorite]);

  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss');

  const hasProp = (string, prop) => {
    return string.indexOf(prop) > -1;
  };

  const recursiveFn = (data, val) => {
    let arr = [];
    data.map((item) => {
      if (item.children) {
        let children = item.children;
        item.children = recursiveFn(children, val);
        if (
          hasProp(item.name, val) ||
          (item.children && item.children.length > 0)
        ) {
          arr.push(item);
        }
      } else if (hasProp(item.name, val)) {
        arr.push(item);
      }
    });
    return arr;
  };

  // 查询事件处理
  const handleSearch = (newParam) => {
    // 前端搜索标签树
    const data = JSON.parse(JSON.stringify(tagTree));
    setTagTreeList(recursiveFn(data, newParam.label));
    const treeIdsList = extractTree(
      recursiveFn(data, newParam.label),
      'children',
    );
    // 找出查询到的所有id
    const ids = treeIdsList.map((i) => i.id);
    setTreeExpanded((oldExpanded) => (oldExpanded.length === 0 ? ids : []));
    setExpanded([]);
    setRefreshTime(dayjs().format('YYYY-MM-DD HH-mm-ss'));
    // 需要找出目录里的子集及其父集
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        // pageSize,
        pageNum: '1',
        time: timestamp,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    // fetchTagTree();
    // setExpanded 点击重置展开所有树
    setTreeExpanded([]);
    setTagTreeList(tagTree);
    setRefreshTime(dayjs().format('YYYY-MM-DD HH-mm-ss'));
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: '1',
      })}`,
    );
  };
  // 新建标签
  const handleCreate = () => {
    setLabelOpen(true);
  };
  //取消弹窗
  const handleCancelLabel = () => {
    setLabelOpen(false);
  };
  return (
    <LabelManageStyled>
      <div
        id="id_mount_parent"
        data-log={JSON.stringify({
          oid: 'page_user_profile_label_management_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <div className="search-condition-left">
          <Button
            data-log={JSON.stringify({
              oid: 'btn_user_profile_label_management_list_create_label',
              events: ['_ev', '_ec'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
            })}
            variant="contained"
            className="label-add-btn"
            onClick={() => MENU_USER_PROFILE_TAG_CREATE && handleCreate()}
            style={
              !MENU_USER_PROFILE_TAG_CREATE
                ? {
                    backgroundColor: '#616161',
                  }
                : {}
            }
          >
            创建标签
          </Button>
          <div className="search-condition-left-tree">
            <SearchCondition
              query={query}
              handleSearch={(par) => handleSearch(par)}
              restClick={handleRestClick}
            ></SearchCondition>
            <SearchTree
              tagTreeList={tagTreeList}
              setTagId={setTagId}
              expanded={expanded}
              setExpanded={setExpanded}
              treeExpanded={treeExpanded}
              setTreeExpanded={setTreeExpanded}
              refreshTime={refreshTime}
            ></SearchTree>
          </div>
        </div>
        <LabelManageResult
          isSearch={isSearch}
          tagId={tagId}
          setIsSearch={setIsSearch}
          modification={modification}
          setModification={setModification}
          fetchTagTree={fetchTagTree}
        ></LabelManageResult>
      </div>
      <ModalML
        open={labelOpen}
        setOpen={setLabelOpen}
        onCancel={handleCancelLabel}
        title={'创建标签'}
        isHasBcg={false}
        onClose={handleCancelLabel}
        isHasIcon={true}
      >
        <LabelModal handleCancelLabel={handleCancelLabel}></LabelModal>
      </ModalML>
    </LabelManageStyled>
  );
};
